import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Trials.css";

/**
 * Accueil — L'entreprise / Expertise (maquette 07).
 * Nom Trials conservé pour ne pas modifier Accueil.jsx.
 * L'image actuelle est une illustration IA, PAS une photographie de l'équipe.
 */
const CONTENT = {
  fr: {
    eyebrow: "L'expertise UniTech Engineering",
    title: "L'innovation pensée pour les réalités du terrain.",
    description:
      "Nous réunissons expertise électronique, systèmes embarqués et connaissance des ascenseurs pour concevoir des solutions fiables et simples à utiliser.",
    expertise: "Conception · Prototypage · Validation · Industrialisation",
    cta: "Découvrir notre entreprise",
    imageAlt:
      "Illustration générée par IA de trois personnes dans un laboratoire d'ingénierie, sans lien avec l'identité de l'équipe UniTech.",
    imageDisclaimer: "Illustration IA · À remplacer par une photo réelle",
    photoNote:
      "Visuel provisoire — une photo de l'équipe, des bancs de test ou du laboratoire devra le remplacer avant publication."
  },
  en: {
    eyebrow: "UniTech Engineering expertise",
    title: "Innovation designed for real-world needs.",
    description:
      "We combine electronics, embedded systems and elevator industry expertise to design reliable solutions that are simple to use.",
    expertise: "Design · Prototyping · Validation · Industrialization",
    cta: "Discover our company",
    imageAlt:
      "AI-generated illustration of three people in an engineering lab, not depicting actual UniTech employees.",
    imageDisclaimer: "AI illustration · Replace with a real photo",
    photoNote:
      "Temporary visual — replace with a real photo of the team, test benches or lab before publishing."
  }
};

export default function Trials() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || "fr")
    .split("-")[0].toLowerCase();
  const fallback = CONTENT[lang] || CONTENT.fr;
  const tr = (key) => t(`trials.expertise.${key}`, { defaultValue: fallback[key] });

  return (
    <section className="unitech-company" aria-labelledby="unitech-company-title">
      <div className="unitech-company__container">
        <div className="unitech-company__layout">
          <div className="unitech-company__visual">
            <figure className="unitech-company__figure">
              <div className="unitech-company__photo-frame">
                <img
                  className="unitech-company__image"
                  src={`${process.env.PUBLIC_URL}/images/unitech-illustration.png`}
                  alt={tr("imageAlt")}
                  loading="lazy"
                  decoding="async"
                  width="1448"
                  height="1086"
                />
              </div>
            </figure>
          </div>

          <div className="unitech-company__content">
            <p className="unitech-company__eyebrow">{tr("eyebrow")}</p>
            <h2 id="unitech-company-title" className="unitech-company__title">
              {tr("title")}
            </h2>
            <p className="unitech-company__description">{tr("description")}</p>
            <p className="unitech-company__expertise">{tr("expertise")}</p>
            <NavLink to="/nous-sommes" className="unitech-company__button">
              <span>{tr("cta")}</span>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.9"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M6 18 18 6M8 6h10v10" />
              </svg>
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
}
